import React, { useState } from "react";
import EmailTemplateEditor from "./EmailTemplateEditor";

function TemplateSettings() {
  const [activeSubsection, setActiveSubsection] = useState("mensaje");

  const subsections = [
    { id: "mensaje", label: "Mensaje" },
    { id: "vacante", label: "Vacante" },
  ];

  return (
    <div className="space-y-6">
      {/* Subsection Selector */}
      <div className="flex gap-2 p-1 bg-gray-100 rounded-lg">
        {subsections.map((subsection) => (
          <button
            key={subsection.id}
            onClick={() => setActiveSubsection(subsection.id)}
            className={`flex-1 px-4 py-2 text-sm font-medium rounded-md transition-colors ${
              activeSubsection === subsection.id
                ? "bg-white text-blue-600 shadow-sm"
                : "text-gray-600 hover:bg-gray-50"
            }`}
          >
            {subsection.label}
          </button>
        ))}
      </div>

      {/* Content Area */}
      <div className="mt-4">
        {activeSubsection === "mensaje" && <EmailTemplateEditor />}
        {activeSubsection === "vacante" && (
          <div className="space-y-4">
            <h4 className="text-lg font-medium text-gray-800 mb-4">
              Configuración de Vacantes
            </h4>
            <div className="flex flex-col items-center justify-center p-8 bg-gray-50 rounded-lg border border-gray-200">
              <div className="w-12 h-12 rounded-full bg-blue-100 flex items-center justify-center mb-4">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6 text-blue-600"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
              </div>
              <h5 className="text-lg font-medium text-gray-900 mb-2">
                Próximamente
              </h5>
              <p className="text-sm text-gray-500 text-center max-w-md">
                Estamos trabajando en nuevas funcionalidades para mejorar tu
                experiencia con las vacantes. Pronto podrás crear y editar
                plantillas para tus vacantes.
              </p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default TemplateSettings;
